(ns frontend.ui.component.lp-portal.report.tearsheet.return-development.style)

(defn table
  []
  {:margin-top "24px"})
